import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=23f3b0d3&scoped=true&"
import script from "./ExportData.vue?vue&type=script&lang=js&"
export * from "./ExportData.vue?vue&type=script&lang=js&"
import style0 from "./ExportData.vue?vue&type=style&index=0&id=23f3b0d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3b0d3",
  null
  
)

export default component.exports